import { adminSubmitOrgStudents } from 'api/admin'
import { assignSelectedStudents } from './assignStudentsApi'

/**
 * Link an existing student account to the current organization.
 * Optionally assigns a counsellor using the existing assign API.
 */
export async function linkStudentToOrganization({ studentId, counselorId }) {
	const id = String(studentId || '').trim()
	if (!id) {
		throw new Error('studentId is required')
	}

	const result = await adminSubmitOrgStudents({ student_id: id })
	const payload = result?.data ?? result

	const counselor = String(counselorId || '').trim()
	if (counselor) {
		await assignSelectedStudents({
			counselorId: counselor,
			studentIds: [id],
		})
	}

	return payload
}
